import { InputNumber, Radio, Divider } from 'antd'
import { useState } from 'react'
import { sparqlFilterTypes } from 'Services/WeaverUtils'

NumberFilter = ({ onOk }) ->

  [filterType, setFilterType] = useState(sparqlFilterTypes.EXACT)
  [value, setValue] = useState(undefined)

  <>
    <h5>Number filter</h5>
    <Divider style={{ margin: '0 0 10px 0' }} />
    <InputNumber
      onChange={(unparsed) ->
        # Do this to remove the `.` in numbers with nothing after the decimal point.
        # Numbers like 123. are valid in js, but not in sparql (Can be 123, or 123.0, but not 123.)
        value = unparsed * 1
        onOk(filterType, value)
        setValue(value)
      }
    />
    <Radio.Group
      defaultValue={sparqlFilterTypes.EXACT}
      style={{ margin: '10px 0 0 0' }}
      size="small"
      onChange={({ target }) ->
        setFilterType(target.value)
        onOk(target.value, value)
      }
    >
      <Radio.Button value={sparqlFilterTypes.LT} data-testid="double-filter-less-than-radio-button">{'<'}</Radio.Button>
      <Radio.Button value={sparqlFilterTypes.EXACT} data-testid="double-filter-equal-to-radio-button">=</Radio.Button>
      <Radio.Button value={sparqlFilterTypes.GT} data-testid="double-filter-greater-than-radio-button">></Radio.Button>
    </Radio.Group>
  </>

export default NumberFilter
